export default __webpack_public_path__ + "static/media/Content-writingCr.661a845d.png";